// @view/payment/choose-subscription/PromoCodeError.view.tsx
import React from "react";
import * as styles from "@styles/Subscription.css";
import type { ChooseSubscriptionViewProps } from "@ps-bridge/contracts/chooseSubscription";

type PromoCodeErrorViewProps = Pick<
  ChooseSubscriptionViewProps,
  "promoCodeErrorMessage"
>;

const PromoCodeErrorView: React.FC<PromoCodeErrorViewProps> = ({
  promoCodeErrorMessage,
}) => (
  <p className={styles.errorText} data-testid="choose-subscription-promo-error">
    {promoCodeErrorMessage}
  </p>
);

export default PromoCodeErrorView;
